(() => {
  if (!customElements.get('sn-nutrition-tools')) {
    customElements.define('sn-nutrition-tools', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const form = this.querySelector('form');
        const result = this.querySelector('.sn-tools__results');
        form.addEventListener('submit', event => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          const data = new FormData(form);
          const age = Number(data.get('age'));
          const height = Number(data.get('height'));
          const weight = Number(data.get('weight'));
          const activity = Number(data.get('activity'));
          if (![age, height, weight, activity].every(Number.isFinite) || !data.get('eligible')) return;
          const bmi = weight / ((height / 100) ** 2);
          const resting = 10 * weight + 6.25 * height - 5 * age + (data.get('sex') === 'male' ? 5 : -161);
          const category = bmi < 18.5 ? 'low' : bmi < 25 ? 'healthy' : bmi < 30 ? 'high' : 'obesity';
          const locale = this.dataset.locale === 'ar' ? 'ar-BH' : 'en-BH';
          this.querySelector('[data-bmi]').textContent = bmi.toLocaleString(locale, {maximumFractionDigits: 1});
          this.querySelector('[data-bmi-category]').textContent = this.dataset[category];
          this.querySelector('[data-calories]').textContent = (Math.round(resting * activity / 10) * 10).toLocaleString(locale);
          result.hidden = false;
        });
        form.addEventListener('reset', () => {result.hidden = true;});
        form.addEventListener('input', () => {result.hidden = true;});
      }
    });
  }
  const bindBrands = root => root.querySelectorAll('.sn-brand-pause').forEach(button => {
    if (button.dataset.bound) return;
    button.dataset.bound = 'true';
    button.addEventListener('click', () => {
      const paused = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(paused));
      button.closest('.sn-brands').classList.toggle('sn-brands--paused', paused);
      button.textContent = paused ? button.dataset.play : button.dataset.pause;
    });
  });
  bindBrands(document);
  document.addEventListener('shopify:section:load', event => bindBrands(event.target));
})();
